import { render, staticRenderFns } from "./CompanyCenter.vue?vue&type=template&id=119d2e3a&scoped=true&"
import script from "./CompanyCenter.vue?vue&type=script&lang=js&"
export * from "./CompanyCenter.vue?vue&type=script&lang=js&"
import style0 from "./CompanyCenter.vue?vue&type=style&index=0&id=119d2e3a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "119d2e3a",
  null
  
)

export default component.exports